import { useDeleteResource__ALPHA } from '@cube3/state/src/redux/components/Hooks/useDeleteResource';
import { useCallback, useMemo } from 'react';

const deleteConfig = { cacheInvalidator: null };

export const useUploadActions = ({ upload, asset }) => {
  const [deleteResource] = useDeleteResource__ALPHA(deleteConfig);

  const onClickRetryUpload = useCallback(() => {
    if (upload?.tusUpload) {
      upload.tusUpload && upload.tusUpload.start();
    }
  }, [upload]);

  const onClickRemoveUpload = useCallback(() => {
    if (asset && upload && upload.progress !== 100) {
      deleteResource({ type: 'asset', id: asset.id });
    }
    if (upload) {
      if (upload.tusUpload) {
        upload.tusUpload.abort(false).then(() => {
          deleteResource({ type: 'file-upload', id: upload.id }, true);
        });
      } else {
        deleteResource({ type: 'file-upload', id: upload.id }, true);
      }
    }
  }, [upload, asset, deleteResource]);

  return useMemo(
    () => ({
      onClickRemoveUpload,
      onClickRetryUpload
    }),
    [onClickRemoveUpload, onClickRetryUpload]
  );
};
